"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  hu: {
    fields: {
      messages: {
        hideNotesConfirm: 'Biztos el akarja rejteni a jegyzetet ? Ez esetben elveszíti a tartalmát.'
      },
      actions: {
        addNote: 'Jegyzet hozzáadása',
        removeNote: 'Jegyzet eltávolítása',
        unlock: 'kinyit'
      }
    }
  }
};
var _default = messages;
exports.default = _default;